import localeAntd from 'ant-design-vue/lib/locale-provider/id_ID'

const messages = {
  topBar: {
    issuesHistory: 'Issues History',
    projectManagement: 'Project Management',
    typeToSearch: 'Search...',
    findPages: 'Find pages...',
    actions: 'Actions',
    status: 'Status',
    profileMenu: {
      hello: 'Hello',
      billingPlan: 'Billing Plan',
      role: 'Role',
      email: 'Email',
      phone: 'Phone',
      // editProfile: 'Edit Profile',
      logout: 'Logout',
    },
    myStore: 'Toko Saya',
  },
  sideBar: {
    dashboard: 'Beranda',
    sales: 'Penjualan',
    orderList: 'Daftar Pesanan',
    orderListDistributor: 'Daftar Penjualan',
    commissionList: 'Daftar Komisi',
    store: 'Toko',
    availableProducts: 'Produk',
    myProducts: 'Produk Saya',
    setting: 'Pengaturan Toko',
    viewStore: 'Lihat Toko',
    account: 'Akun',
    editProfile: 'Pengaturan Akun',
    ewalletHistory: 'Mutasi E-wallet',
    withdrawRequest: 'Penarikan E-wallet',
    purchase: 'Pembelian',
    purchaseList: 'Daftar Pembelian',
    createPurchase: 'Buat Pembelian',
    purchaseCatalogue: 'Katalog',
  },
  authForm: {
    loginFailed: 'Login Gagal',
    registerFailed: 'Daftar Gagal',
    invalidPassword: 'Kata sandi Invalid',
    invalidPasswordOrUsername: 'Email atau kata sandi yang anda masukan tidak valid',
    emailNotFound: 'Email tidak ditemukan',
    systemBusy:
      'System sibuk, cobalah beberapa saat lagi atau kontak administrator!',
    tankYou: 'Terimakasih',
    forgotpassSucces:
      'Cek email anda untuk melengkapi proses perubahan kata sandi',
    forgotpassFailed: 'Setel ulang kata sandi gagal',
    passwrdNotmatch: 'Kata sandi berbeda!',
    resetpassFailed: 'Setel ulang kata sandi gagal',
    resetpassSuccess: 'Setel ulang kata sandi sukses',
    loginTitle: 'Reseller Dropshipper',
    signInDesc: 'Masuk ke akun anda',
    requiredEmail: 'Mohon masukan alamat email anda!',
    formatEmail: 'Format alamat email salah!',
    requiredPassword: 'Mohon masukan kata sandi anda!',
    signIn: 'Masuk',
    //
    dontHaveAccount: 'Belum mempunyai akun?',
    register: 'Daftar',
    forgotPassword: 'Lupa kata sandi?',
    resetPass: 'Setel Ulang Kata Sandi',
    resetMyPass: 'Submit',
    emailAddress: 'Alamat Email',
    goToSignIn: 'Kembali ke halaman login',
    newPass: 'Kata Sandi Baru',
    confirmNewPass: 'Konfirmasi Kata Sandi Baru',
    createAccount: 'Buat Akun',
    firstName: 'Nama Depan',
    requiredFirstName: 'Mohon masukan nama depan anda!',
    lastName: 'Nama Belakang',
    requiredLastName: 'Mohon masukan nama belakang anda',
    password: 'Kata Sandi',
    confirmPassword: 'Konfirmasi Kata Sandi',
    toc: 'Dengan melakukan pendaftaran, anda setuju dengan',
    and: 'dan',
    alreadyHaveAccount: 'Sudah mempunyai akun?',
    registerSuccess:
      'Silahkan check email anda: {email}, untuk melengkapi proses pendaftaran',
    regConfirmation: 'Konfirmasi Pendaftaran',
    storeName: 'Nama Toko',
    requiredStoreName: 'Mohon masukan nama toko anda',
    validator: 'Hanya tanda "-" yang diperbolehkan',
    storeUrl: 'Url Toko',
    helpStoreUrl:
      'Mohon pastikan url toko anda sudah benar. Anda tidak bisa menggantinya setelah melakukan pendaftaran',
    requiredStoreUrl: 'Mohon masukan url toko anda',
    phoneNumber: 'Nomer Telepon',
    requiredPhoneNumber: 'Mohon masukan nomer telepon anda',
    address: 'Alamat',
    requiredAddress: 'Mohon masukan alamat anda',
    address2: 'Alamat 2',
    requiredAddress2: 'Mohon masukan alamat anda (opsional)',
    country: 'Negara',
    city: 'Kota',
    placeCity: 'Pilih Kota',
    area: 'Kelurahan',
    placeArea: 'Pilih Kelurahan',
    zip: 'Kode Pos',
    requiredZip: 'Kode Pos harus berupa angka',
    bankInformation: 'Informasi Bank',
    accountNo: 'Nomer Rekening.',
    requiredAccountNo: 'Nomer Rekening harus berupa angka',
    accountHolder: 'Nama Pemilik Akun Bank',
    placeAccountHolder: 'Mohon masukan nama pemilik Akun Bank',
    bankAccount: 'Bank Akun',
    placeBankAcc: 'Pilih Bank',
    idCard: 'Kartu Indentitas (KTP/SIM)',
    popUpRemoveImage: 'Kamu yakin untuk menghapus foto ini?',
    removeImage: 'Hapus foto',
    toc2: 'Saya setuju dengan syarat dan ketentuan yang berlaku',
    submitConRegister: 'Submit',
    registerCompleted:
      'Konfirmasi Pendaftaran. Silahkan login untuk melanjutkan',
    requiredCity: 'Mohon pilih kota anda',
    requiredArea: 'Mohon pilih kelurahan anda',
    requiredBankAcc: 'Mohon pilih akun bank',
    requiredBankAccName: 'Mohon masukan nama pemilik aku bank',
    requiredToc2: 'Please check term and condition',
    extraNpwp:
      'Jika kamu mempunyai NPWP, komisi akan dipotong pajak 5%, jika tidak dipotong 6%. Kamu bisa menambahkan NPWP dilain waktu pada pengaturan akun, jika belum mempunyai sekarang.',
  },
  dashboard: {
    weeklySales: 'Penjualan Mingguan',
    onProcess: 'Pesanan di Proses',
    completedOrders: 'Pesanan Selesai',
    refundRequest: 'Permintaan Pembatalan Pesanan',
    ewallet: 'E-wallet',
    totalCommission: 'Total Komisi',
    onComingCommission: 'Komisi pada Transaksi Selanjutnya',
    bestSeller: 'Produk Terlaris',
    productNotFound: 'Produk Tidak Ditemukan',
    lastSoldItems: 'Produk Terakhir Dijual',
  },
  sales: {
    date: 'Tanggal',
    orderNumber: 'Nomer Pesanan',
    productName: 'Nama Produk',
    commission: 'Komisi',
    searchResult: 'Hasil Pencarian',
    searchCommission: 'Cari berdasarkan nomer pesanan',
    search: 'Search',
    notifSearch: 'Mohon masukan nomer pesanan atau range tanggal',
    orderNumberDate: 'Nomer Pesanan dan Tanggal',
    customerNameAddress: 'Nama Pembeli dan Alamat Pengiriman',
    status: 'Status',
    actions: 'Actions',
    all: 'Semua Pesanan',
    onComingCommission: 'Komisi pada Pesanan Selanjutnya',
    finishedOrdered: 'Pesanan Selesai',
    cancelRequest: 'Permintaan Pembatalan Pesanan',
    canceled: 'Pembatalan Pesanan',
    customerInfo: 'Informasi Pembeli',
    name: 'Nama',
    phone: 'Nomer Telepon',
    email: 'Email',
    paymentInformation: 'Informasi Pembayaran',
    totalPayment: 'Total Pembayaran',
    totalShop: 'Total Belanja',
    paymentStatus: 'Status Pembayaran',
    paymentMethod: 'Metode Pembayaran',
    shippingInforamtion: 'Informasi Pengiriman',
    amount: 'Harga',
    totalItemPrice: 'Total Harga Seluruh Item',
    shippingCost: 'Biaya Pengiriman',
    insuranceCost: 'Biaya Asuransi',
    voucher: 'Voucher',
    discount: 'Discount',
    total: 'Total',
    waitingPayment: 'Menunggu Pembayaran',
  },
  store: {
    allProduct: 'Semua Produk',
    selectAll: 'Pilih Semua',
    addToStore: 'Tambahkan ke Toko',
    removeFromStore: 'Keluarkan dari Toko',
    searchProduct: 'Cari Berdasarkan Nama Produk',
    productInStore: 'Produk ada di Toko',
    productOutStore: 'Produk tidak ada di Toko',
    productNotFound: 'Produk Tidak Ditemukan',
    loadMore: 'Muat Lebih Banyak',
    alreadyInStore: 'Sudah Ada di toko',
    price: 'Harga untuk {value} variant',
    commission: 'Komisi',
    fotoProfile: 'Logo Toko',
    changeImage: 'Ganti Logo',
    addImage: 'Tambah Logo',
    storeName: 'Nama Toko',
    requiredStoreName: 'Mohon masukan nama toko anda',
    notifStoreUrl: 'Anda tidak bisa merubah url toko',
    save: 'Simpan',
    selectedBanner: 'Banner yang Dipilih',
    availableBanner: 'Banner yang Tersedia:',
    profileSetting: 'Pengaturan Toko',
    bannerSetting: 'Pengaturan Banner',
    storeUrl: 'Url Toko',
    successAddProduct: 'Menambahkan produk ke toko sukses',
    failedAddProduct: 'Menambahkan produk ke toko gagal',
    successRemoveProduct: 'Mengeluarkan produk dari toko sukses',
    failedRemoveProduct: 'Mengeluarkan produk dari toko sukses',
    successEditStore: 'Edit profile toko sukses',
    failedEditStore: 'Edit porfile toko gagal',
    requiredStoreFoto: 'Mohon masukan logo toko',
    outOfStock: 'Stok Kosong',
    shareThisProduct: 'Bagikan produk ini',
    shareProduct: 'Bagikan Produk {value}',
    extraDefaultMessage:
      'Jika kamu tidak menulis pesan. Sistem akan membuat default pesan secara otomatis',
    placeholderDefaultMessage: 'Tuliskan pesan anda (optional)',
    shareWith: 'Bagikan dengan',
    changeDefaultMessage:
      '*Kamu bisa mengganti default message diatas, dengan mengisi text dibawah ini.',
    stock: 'Stok',
    updateStock: 'Ubah stok',
    color: 'Warna',
    size: 'Ukuran',
    flavour: 'Rasa',
    saveChanges: 'Simpan perubahan',
    changeStockSuccess: 'Perubahan stok produk berhasil disimpan',
  },
  account: {
    firstName: 'Nama Depan',
    requiredFirstName: 'Mohon masukan nama depan anda',
    lastName: 'Nama Belakang',
    requiredLastName: 'Mohon masukan nama belakang anda',
    phoneNumber: 'Nomer Telepon',
    requiredPhoneNumber: 'Mohon masukan nomer telepon',
    address: 'Alamat',
    requiredAddress: 'Mohon masukan alamat anda',
    address2: 'Alamat 2',
    requiredAddress2: 'Mohon masukan alamat anda (optional)',
    city: 'Kota',
    area: 'Kelurahan',
    addBank: 'Tambah Bank Akun',
    bankInformation: 'Informasi Bank Akun',
    accountNo: 'Nomer Rekening',
    accountHolder: 'Nama Pemilik Akun',
    inputData: 'Mohon Masukan Data Anda',
    bankAccount: 'Bank Akun',
    changeBank: 'Ganti Bank Akun',
    ewalletSaldo: 'E-wallet saldo',
    withdrawAmount: 'Jumlah Penarikan',
    helpWithdraw:
      'Minimal E-wallet saldo untuk permintaan penarikan dana Rp. {value}',
    dataCorrect: 'Semua data diatas sudah benar',
    notifSuccessWithdraw: 'Permintaan Penarikan E-wallet Sukses',
    notifSuccessWithdraw2:
      'Kami telah  menerima permintaan pencairan dana anda dan akan diproses selambat-lambatnya 1 × 24 jam kerja',
    successEditProfile: 'Edit Profile Sukses',
    failedEditProfile: 'Edit Profile Gagal',
    requiredFotoProfile: 'Mohon masukan foto profile anda',
    editBankSuccess: 'Edit akun bank sukses',
    editBankFailed: 'Edit akun bank gagal',
    addBankSuccess: 'Menambahkan akun bank sukses',
    addBankFailed: 'Menambahkan akun bank gagal',
    modalDeleteBank: 'Apakah kamu yakin akan menghapus akun bank ini?',
    deleteBankSuccess: 'Hapus akun bank sukses',
    deleteBankFailed: 'Hapus akun bank gagal',
    notEnoughEwallet: 'Saldo Ewallet anda tidak mencukupi',
    minimumEwallet: 'Minimal jumlah penarikan Ewallet Rp. {value}',
    totalEwalletAmmount: 'Jumlah Ewallet yang akan di tarik:',
    willTransfer: 'Akan di transfer ke:',
    changeImageNpwp: 'Ganti NPWP',
    addImageNpwp: 'Tambah NPWP',
    noData: 'Data tidak ditemukan',
    all: 'Semua',
    commission: 'Komisi',
    withdraw: 'Penarikan',
    tax: 'Pajak',
    editBank: 'Edit Bank Akun',
    lastWithdraw: 'Penarikan Komisi Terakhir',
    date: 'Tanggal',
    status: 'Status',
    withdrawEwallet: 'Tarik Ewallet',
  },
  purchase: {
    payment: {
      information: 'Informasi Pembayaran',
      total: 'Total Pembayaran',
      status: 'Status Pembayaran',
      method: 'Metode Pembayaran',
      reference: 'Referensi Pembayaran',
      instructions: 'Instruksi Pembayaran',
    },
    state: {
      created: 'Pesanan dibuat',
      canceled: 'Dibatalkan',
      paid: 'Pesanan sudah dibayar',
      waitingPayment: 'Menunggu pembayaran',
      payment: 'Pembayaran',
      paymentExpired: 'Pembayaran melebihi batas waktu',
      expired: 'Pembayaran kadarluarsa',
      processing: 'Dalam proses',
      shipping: 'Pengiriman',
      shipped: 'Sudah terkirim',
      delivered: 'Sudah diterima',
      notDeliveredYet: 'Belum diterima',
      finish: 'Selesai',
    },
    shipping: {
      information: 'Informasi pengiriman',
      name: 'Nama penerima',
      phone: 'Telepon penerima',
      address: 'Alamat penerima',
      detail: 'Detail Pengiriman',
      change: 'Ubah Data Pengiriman',
      select: 'Pilih Data Pengiriman',
      method: 'Metode Pengiriman',
    },
    billing: {
      change: 'Ubah Billing Data',
      select: 'Pilih Billing Data',
    },
    awb: 'No. Resi',
    courier: 'Kurir',
    poNumber: 'PO Number',
    orderNumber: 'Order Number',
    createdAt: 'Tanggal Pembelian',
    deliveryExpectations: 'Ekspektasi Pengiriman',
    total: 'Total Value',
    note: 'Note',
    createNew: 'Buat Baru',
    addProduct: 'Tambah Product',
    price: 'Harga',
    discount: 'Diskon',
    nomralPrice: 'Harga Normal',
  },
}

export default {
  locale: 'id-ID',
  localeAntd,
  messages,
}
